import type { FeedbackMessages } from './en';

const pt: FeedbackMessages = {
  qualified: {
    title: 'Obrigado por concluir este estudo!',
    text: 'Já pode fechar a janela do navegador.\n\nEsperamos vê-lo novamente em breve.',
  },
  quotaFull: {
    title: 'Este estudo está encerrado',
    text: 'Obrigado pelo seu interesse no nosso estudo.\n\nInfelizmente, já recebemos todas as respostas de que precisávamos.\n\nEsperamos vê-lo num dos nossos futuros estudos!',
  },
  terminated: {
    title: 'Obrigado por compartilhar o seu feedback!',
    text: 'Esperamos vê-lo em breve nos nossos futuros estudos. Até então, desejamos-lhe um ótimo dia.\n\nPor favor, feche esta janela do navegador.',
  },
  mismatch: {
    title: 'Obrigado pelo seu interesse',
    text: 'Infelizmente, não pertence ao público-alvo deste estudo específico.\n\nPode fechar esta página.',
  },
  error: {
    title: 'Não conseguimos processar o seu pedido',
    linkProblemDetailed:
      'O link que seguiu está com problemas. Verifique se o link na barra de endereço corresponde ao que lhe foi fornecido e tente novamente.',
    linkProblemGeneric: 'O link que seguiu está com problemas. Tente novamente, por favor.',
    contactPerson:
      'Se o problema persistir, informe a pessoa que lhe enviou o link sobre este problema.',
  },
};

export default pt;
